import axios from "axios";
import { resetCsrf, initCsrf } from "../auth/csrf";

export const practitionerHttpService = axios.create({
  withCredentials: true,
});

practitionerHttpService.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 419 && !error.config._csrfRetried) {
      error.config._csrfRetried = true;
      resetCsrf();
      await initCsrf();
      return practitionerHttpService.request(error.config);
    }
    return Promise.reject(error);
  },
);
